import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
// Landing route (Malla): the mesh nodes panel IS the dashboard. It ships in the
// main bundle (NOT lazy) so it renders directly with the shell on cold entry.
// The former POS Dashboard is contracted away (see docs/MALLA_OVERVIEW.md).
import { MeshPanel } from "@/features/mesh/components/mesh-panel";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui";
import { useI18n } from "@/providers/i18n-provider";

function IndexPage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Mesh`)}
      description={t(
        msg`Manage your mesh VPN: enroll devices, watch node liveness, download WireGuard configs and track bandwidth-contribution credits.`,
      )}
    >
      <PageContainer maxWidth="3xl">
        <MeshPanel />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: IndexPage,
});
